import { post } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

// get
function salesAdvisorSeasonProgramSeasonPostulantSearch (pFormdata, pIdSalesAdvisor, pIdSeason, pPage) {
    const URI = `${BASE_URL}/api/salesAdvisors/${pIdSalesAdvisor}/seasons/${pIdSeason}/programSeasonPostulant-search?page=${pPage}`
    return post(URI, pFormdata, { headers })
}

export { salesAdvisorSeasonProgramSeasonPostulantSearch }